.graphHeader {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	margin: 16px 0 12px 0;
	gap: 12px;
}

.periodSelectorWrapper {
	display: flex;
	gap: 8px;
}

.periodSelector {
	padding: 6px 12px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	background-color: white;
	color: #374151;
	font-size: 14px;
	cursor: pointer;
	font-weight: 500;

	&:hover {
		border-color: #7fb02f;
	}

	&.active {
		background-color: #7fb02f;
		color: white;
		border-color: #7fb02f;
	}
}

.toggleWrapper {
	display: flex;
	justify-content: center;
	gap: 0;
	margin-bottom: 10px;
}

.toggleButton {
	padding: 6px 14px;
	font-size: 13px;
	border: 1px solid #d1d5db;
	background-color: #fff;
	color: #374151;
	cursor: pointer;
	transition: background-color 0.2s;
	border-radius: 0;

	&:first-child {
		border-top-left-radius: 6px;
		border-bottom-left-radius: 6px;
	}

	&:last-child {
		border-top-right-radius: 6px;
		border-bottom-right-radius: 6px;
		border-left: none;
	}

	&:hover {
		border-color: #7fb02f;
	}

	&.active {
		background-color: #7fb02f;
		color: white;
		border-color: #7fb02f;
	}
}

.filtersForm {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 16px;
}

.filtersSelect {
	display: flex;
	flex-direction: row;
	gap: 10px;
	width: 100%;

	.select {
		flex: 1;
		font-size: 13px;
	}

	.selectWrapper {
		flex: 1;
	}
}

.buttonApplyWrapper {
	display: flex;
	justify-content: flex-end;
}

.buttonApply {
	background-color: #7fb02f;
	color: white;
	font-size: 13px;
	font-weight: 500;
	padding: 6px 16px;
	border-radius: 6px;
	border: none;
	cursor: pointer;

	&:hover {
		background-color: #5a8217;
	}
}
